import type { IPlugin, PluginContext } from '../../core/types';
import { StreamInfo } from './StreamInfo';

export class StreamInfoPlugin implements IPlugin {
  readonly name = 'stream-info';

  private ctx: PluginContext | null = null;

  init(ctx: PluginContext): void {
    this.ctx = ctx;
    ctx.uiRegistry.register('stream-info', StreamInfo);
    ctx.logger.debug('StreamInfoPlugin initialized');
  }

  destroy(): void {
    this.ctx?.uiRegistry.unregister('stream-info', StreamInfo);
    this.ctx = null;
  }
}
